<template>
  <div class="card-page-container mdl-shadow--2dp">
    <parameters-form></parameters-form>
  </div>
</template>

<script>
  var api = require('api')
  module.exports = {
    ready: function () {
    },
    components: {
      parametersForm: require('a/forms/ParametersForm')
    },
    methods: {
      onSuccess: function () {
        this.$dispatch('loading', false)
        this.$dispatch('show-success', 'admin.parameters.success.label')
        this.$emit('back')
      },
      onError: function (err) {
        this.$dispatch('loading', false)
        this.$dispatch('show-error', err)
      }
    },
    events: {
      'save-parameters': function (data) {
        this.$dispatch('loading', true)
        api.AppConfig.save(data).then(this.onSuccess, this.onError)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Parameters.vue?07742372